
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-angle-left"
                  iconPos="left" label="{{ 'promotion.backToDetail' | translate }}"
                  (click)="locationBack()">
                </button>
              </div>
            </div>
          </div>
          <form (ngSubmit)="save()" [formGroup]="formData">
            <div class="ui-g form-group">
              <div [kv-form-element]="{ label: 'customerInfoSheet.startDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="start_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'customerInfoSheet.endDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="end_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'promotion.startRedemDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="start_redem_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'promotion.endRedemDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="end_redem_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="description"/>
              </div>
              <div [kv-form-element]="{ label: 'promotion.messages', md: '3' }">
                <p-dropdown
                  [options]="messages"
                  formControlName="message_id">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: '', md: '1' }" style="padding-top: 30px; text-align: -webkit-center;">
                <td class="btn-list">
                  <p-button [disabled]="formData.controls['message_id'].disabled" pTooltip="{{ 'common.edit' | translate }}" icon="fa fas fa-edit" styleClass="ui-button-info" (onClick)="createNewMessage()"></p-button>
                </td>
              </div>
              <div [kv-form-element]="{ label: 'promotion.divisions', md: '4' }">
                <p-multiSelect
                  class="multiselect-container"
                  [options]="divisionSaleNetworkItems"
                  formControlName="dsnList"
                  [filter]="true"
                  scrollHeight="350px"
                  maxSelectedLabels="1"
                  styleClass="multiselect-fixed-height">
                </p-multiSelect>
              </div>
              <div class="ui-g-12 text-right">
                <button
                  pButton
                  type="submit"
                  class="k-generic-btn"
                  icon="fa fa-floppy-o"
                  iconPos="left"
                  label="{{ 'common.saveAndBackToList' | translate }}"
                  [disabled]="formData.controls['start_date'].value > formData.controls['end_date'].value ||
                  formData.controls['start_redem_date'].value > formData.controls['end_redem_date'].value ||
                  formData.controls['start_date'].value === null ||
                  formData.controls['end_date'].value === null ||
                  formData.controls['start_redem_date'].value === null ||
                  formData.controls['end_redem_date'].value === null ||
                  formData.controls['message_id'].value === null ||
                  formData.controls['dsnList'].value === null ||
                  formData.controls['dsnList'].value.length <= 0">
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/detail/tab-detail-form.component.ts.TabDetailFormComponent.html